import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "../Navbar";
import { Footer } from "../Footer";
import { FloatingWhatsApp } from "../FloatingWhatsApp";
import { ChatWidget } from "../ChatWidget";
import { CookieBanner } from "../CookieBanner";

export const PageShell = ({ children, testid }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#04120E] min-h-screen" data-testid={testid}>
      <Navbar basePath="/" />
      <main>{children}</main>
      <Footer />
      <FloatingWhatsApp />
      <ChatWidget />
      <CookieBanner />
    </div>
  );
};
